export const SUPPLIER_PROFILE_SUBMIT_BEGIN = "SUPPLIER_PROFILE_SUBMIT_BEGIN";
export const SUPPLIER_PROFILE_SUBMIT_SUCCESS = "SUPPLIER_PROFILE_SUBMIT_SUCCESS";
export const SUPPLIER_PROFILE_UPLOAD_BEGIN = "SUPPLIER_PROFILE_UPLOAD_BEGIN";
export const SUPPLIER_PROFILE_SUBMIT_FAIL = "SUPPLIER_PROFILE_SUBMIT_FAIL";

//
//  ******* Fetch Supplier Info *******
//

export const SUPPLIER_PROFILE_FETCH_BEGIN = "SUPPLIER_PROFILE_FETCH_BEGIN";
export const SUPPLIER_PROFILE_FETCH_SUCCESS = "SUPPLIER_PROFILE_FETCH_SUCCESS";
export const SUPPLIER_PROFILE_FETCH_FAIL = "SUPPLIER_PROFILE_FETCH_FAIL";
